import { TopFrequencyModel } from 'api-hooks/guest';
import { capitalize } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { CardContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  type:
    | 'airline'
    | 'hotel'
    | 'cruise'
    | 'travel_document'
    | 'activity'
    | 'product';
  data: TopFrequencyModel[];
  isLoading: boolean;
}

export default function TopTable(props: Props) {
  const { t } = useTranslation();
  const { data, type, isLoading } = props;

  const columns = React.useMemo<IColumn<TopFrequencyModel>[]>(
    () => [
      {
        header: t('common:number'),
        accessorKey: 'rank',
        minSize: 40,
        maxSize: 40,
        cell: ({ row }) => <>{row.index + 1}</>,
      },
      {
        header: t(`common:${type}`),
        accessorKey: 'name',
        minSize: 100,
        cell: ({ getValue }) => (
          <>
            {type === 'travel_document'
              ? capitalize(getValue() as string)
              : (getValue() as string)}
          </>
        ),
      },
      {
        header: t('common:frequency'),
        accessorKey: 'frequency',
        minSize: 100,
        maxSize: 100,
      },
    ],
    [t, type],
  );

  return (
    <CardContainer $style={{ minHeight: '400px' }}>
      <Text variant="HeadingXSmall">Top {t(`common:${type}`)}</Text>
      <Separator gap={16} />
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data || []}
      />
    </CardContainer>
  );
}
